class HeaderMessage {
  constructor() {
    this.visible = false;
    this.class = {
      visible: 'is-visible',
      error: 'is-error',
      success: 'is-success',
    };
    this.elements = {
      container: document.querySelector('.hdr-message'),
      content: document.querySelector('.hdr-message-inner'),
      close: [...document.querySelectorAll('.hdr-message-close')],
    };

    this.bindEvents();
  }

  open(type) {
    if (this.class.hasOwnProperty(type)) {
      this.elements.container.classList.add(this.class[type]);
    }
    this.elements.container.classList.add(this.class.visible);
    this.visible = true;
  }

  close() {
    for (let item in this.class) {
      this.elements.container.classList.remove(this.class[item]);
    }
    this.visible = false;
  }

  addContent(content) {
    this.elements.content.innerHTML(content);
  }

  removeContent() {
    this.elements.content.innerHTML('');
  }

  bindEvents() {
    this.elements.close.map(closeBtn => {
      closeBtn.addEventListener('click', event => {
        event.preventDefault();
        this.close();
      });
    });
  }
}

export default new HeaderMessage();



// WEBPACK FOOTER //
// ./src/js/header-message.js